<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Footer
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Global sidfot i
      <span
        class="font-mono text-[13px] bg-[#f2f4f6] px-1.5 py-0.5 rounded-[5px]"
        >AppLayout.vue</span
      >. Logotyp och copyright till vänster, navigeringslänkar till höger. På
      mobil staplas kolumnerna vertikalt.
    </p>

    <PreviewFull label="Desktop">
      <div
        class="w-full rounded-xl py-10 px-8"
        style="background: #f2f4f6; border: 1px solid #eceef0"
      >
        <div
          class="flex flex-col md:flex-row items-start justify-between gap-8"
        >
          <!-- Logo + copyright -->
          <div class="flex flex-col gap-2">
            <EmmalagatLogo width="163" />
            <p class="text-xs text-[#6c7a77] leading-relaxed m-0">
              © 2026 Emmalagat. Handgjort med kärlek<br />och socker.
            </p>
          </div>

          <!-- Footer links -->
          <div class="flex flex-wrap gap-6 md:gap-10">
            <span
              v-for="link in footerLinks"
              :key="link"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase cursor-pointer hover:text-teal-500 transition-colors"
              >{{ link }}</span
            >
          </div>
        </div>
      </div>
    </PreviewFull>

    <PreviewFull label="Mobil">
      <div
        class="w-full max-w-[390px] rounded-xl py-8 px-6"
        style="background: #f2f4f6; border: 1px solid #eceef0"
      >
        <div class="flex flex-col gap-8">
          <div class="flex flex-col gap-2">
            <EmmalagatLogo width="120" />
            <p class="text-xs text-[#6c7a77] leading-relaxed m-0">
              © 2026 Emmalagat. Handgjort med kärlek och socker.
            </p>
          </div>
          <div class="flex flex-wrap gap-5">
            <span
              v-for="link in footerLinks"
              :key="link"
              class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase cursor-pointer"
              >{{ link }}</span
            >
          </div>
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import EmmalagatLogo from "@/components/icons/EmmalagatLogo.vue";
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const footerLinks = [
  "Alla recept",
  "Kategorier",
  "Tekniker & verktyg",
  "Instagram",
  "Designsystem",
];

const htmlCode = `<!-- Del av AppLayout.vue -->
<footer class="bg-[#f2f4f6] border-t border-[#eceef0] py-10">
  <div class="max-w-[1280px] mx-auto px-4 md:px-6">
    <div class="flex flex-col md:flex-row items-start justify-between gap-8">

      <!-- Logo + copyright -->
      <div class="flex flex-col gap-2">
        <Link :href="navData.rootPath" class="flex items-center gap-2.5">
          <EmmalagatLogo width="163" />
        </Link>
        <p class="text-xs text-[#6c7a77] leading-relaxed">
          © 2026 Emmalagat. Handgjort med kärlek<br />och socker.
        </p>
      </div>

      <!-- Navigeringslänkar -->
      <div class="flex flex-wrap gap-6 md:gap-10">
        <Link
          href="/recept"
          class="font-semibold text-xs text-[#191c1e] tracking-widest uppercase no-underline hover:text-teal-500 transition-colors"
        >Alla recept</Link>
        <!-- Upprepa för övriga länkar -->
      </div>

    </div>
  </div>
</footer>`;

const cssCode = `/* Footer-container */
background: #f2f4f6;
border-top: 1px solid #eceef0;
padding-top: 40px;
padding-bottom: 40px;   /* py-10 */

/* Layoutbredd */
max-width: 1280px;
padding-left: 16px;   /* px-4 */
padding-right: 16px;
/* desktop: px-6 = 24px */

/* Copyright-text */
font-size: 12px;       /* text-xs */
color: #6c7a77;
line-height: 1.625;    /* leading-relaxed */

/* Footerlänkar */
font-weight: 600;      /* font-semibold */
font-size: 12px;       /* text-xs */
color: #191c1e;
letter-spacing: 0.1em; /* tracking-widest */
text-transform: uppercase;
text-decoration: none;
transition: color 150ms;
/* Hover: color #14b8a6 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
